import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router';
import {useAuthStore, fetchData} from '../utils/member';

const routes = [
    {
        path: '/',
        // path: "/user/:id",
        // path: "/user/:id/name/:name",
        // path: "/user/:id/name/:name?",
        name: 'index-home', //配置名称
        //配置别名
        alias: ["/home", "/index"],
        // alias: "/home",
        component: () => import('../views/Home.vue'),
        // 配置路径别名@
        //     component: () => import("@/views/Home.vue"),
        meta: {
            requiresAuth: false,
            title: "首页",
        }  // 标记不需要检测
    },
    {
        path: '/about',
        name: 'index-about',
        component: () => import('../views/About.vue'),
        meta: {
            requiresAuth: true,
            title: "关于我们",
        }  // 标记需要登录的路由
    },
    {
        path: '/member/login',
        name: 'member-login',
        meta: {
            requiresAuth: false,
            title: "登录",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/Member/login.vue'),
    },
    {
        path: '/member/logout',
        name: 'member-logout',
        meta: {
            requiresAuth: false,
            title: "注销",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/Member/logout.vue'),
    },
    {
        path: '/member/register',
        name: 'member-register',
        meta: {
            requiresAuth: false,
            title: "注销",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/Member/register.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        meta: {
            requiresAuth: false,
            title: "页面未找到",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/NotFound.vue'),
    },
    {
        path: '/news',
        name: 'index-news',
        meta: {
            requiresAuth: false,
            title: "新闻资讯",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/News.vue'),
    },
    {
        path: '/news/newsDetail/:id',
        name: 'news-detail',
        meta: {
            requiresAuth: false,
            title: "资讯详情",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/News/newsDetail.vue'),
    },
    {
        path: '/serve',
        name: 'index-serve',
        meta: {
            requiresAuth: false,
            title: "服务大厅",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/Serve.vue'),
    },
    {
        path: '/member',
        name: 'index-member',
        meta: {
            requiresAuth: false,
            title: "会员服务",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/Member.vue'),
    },
    {
        path: '/media',
        name: 'index-media',
        meta: {
            requiresAuth: false,
            title: "多媒体服务",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/Media.vue'),
    },
    {
        path: '/report',
        name: 'index-report',
        meta: {
            requiresAuth: false,
            title: "报告",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/Report.vue'),
    },
    {
        path: '/caravan',
        name: 'index-caravan',
        meta: {
            requiresAuth: false,
            title: "大篷车",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/Caravan.vue'),
    },
    {
        path: '/activity',
        name: 'index-activity',
        meta: {
            requiresAuth: false,
            title: "活动中心",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/Activity.vue'),
    },
    {
        path: '/franchise',
        name: 'index-franchise',
        meta: {
            requiresAuth: false,
            title: "加盟合作",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/Franchise.vue'),
    },
    {
        path: '/activity/actDetail/:id',
        name: 'act-detail',
        meta: {
            requiresAuth: false,
            title: "资讯",
        }  // 标记需要登录的路由
        ,
        component: () => import('../views/News/newsDetail.vue'),
    }
]

const router = createRouter({
    // 1. 使用传统url模式
    // history: createWebHistory(),
    //  history: createWebHistory(process.env.BASE_URL), //依赖于服务器的路径配置

    // 2. 使用带#号的哈希模式
    history: createWebHashHistory(), //使用 hash 模式（URL 中有 #）不依赖于服务器的路径配置
    //   history: createWebHistory('/my-folder/'), // 与 Vite 的 base 保持一致
    routes
})


//------------------------------------------------
//全局前置守卫 是最常用的全局前置守卫，它会在每次路由切换之前被调用。您可以在这个守卫中执行一些全局的逻辑，比如检查用户是否已登录、设置页面标题、记录用户访问的 URL 等。
router.beforeEach(async (to, from, next) => {
    // const authStore = useAuthStore();
    // const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    // // const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true'
    // if (requiresAuth && !authStore.isAuthenticated) {
    //     console.log('check failed');
    //     //  alert('身份检测失败!')
    //     next({name: 'member-login'});
    //     //         next({ path: '/login' });
    // } else {
    //     // 异步获取数据
    //     try {
    //         //  await fetchData();
    //         next();
    //     } catch (error) {
    //         next(false);
    //     }
    // }

    next();
});
//------------------------------------------------
//全局解析守卫 是在导航被确认之后，但在组件实例被创建之前调用的。这个守卫可以用于在组件渲染之前获取数据或执行其他异步操作。
router.beforeResolve((to, from, next) => {
    // 在这里可以执行一些异步操作，例如获取数据
    fetchData().then(res => {
        console.log("fetchData:A", res)
    }).catch(e => {
        console.log("fetchData:B", e)
    });
    next();
});
//------------------------------------------------
//全局后置守卫 它不会接收 next 函数，因此不能影响导航过程。通常用于记录日志、分析用户行为、设置页面标题
router.afterEach((to, from) => {
    document.title = to.meta.title || '';
    console.log(`Navigated from ${from.path} to ${to.path}`);
});

export default router


//   字符串格式： <router-link to="/about">About</router-link>
//   对象格式： <router-link :to="{ name: 'about', params: { userId: 123 }}">About</router-link>
//   <router-link :to="{ path: '/home'}" replace></router-link> 如果配置了replace，则在点击该链接，将会导致history记录被清空，不能再执行回退。


/*
this.$router.go(-1) ：代表着后退
this.$router.go(1)：代表着前进


<p>
    <button @click="previous">前进</button>
    <button @click="next">后退</button>
</p>
methods: {
    //前进
    previous: function() {
        this.$router.go(1);
    },
    //后退
    next: function() {
        this.$router.go(-1);
    }
}






 */